// test342
(342 && 0);
